export default __webpack_public_path__ + "static/media/bullet-icons.57064c44.png";